import * as React from 'react';
import { Trans } from 'react-i18next';

import ProfileImage from '@common/components/profile-image';
import { EventItemComponent } from './event-item';
import type { EventForAdminDto } from '../../types';
import LinkWrapper from '@common/components/linkWrapper';
import { useParams } from 'react-router';

type Props = {
  item: EventForAdminDto;
  onClick: (item: EventForAdminDto) => unknown;
  onEdit: (item: EventForAdminDto) => unknown;
  onDuplicate: (item: EventForAdminDto) => unknown;
};

export const EventItemAdminComponent = ({ item, onClick, onEdit, onDuplicate }: Props) => {
  const { networkId } = useParams<{ networkId: string }>();
  const baseUrl = networkId ? `/networks/${networkId}` : '/admin';
  return (
    <EventItemComponent
      item={item}
      maxGuestLimit={item.settings?.max_guest_limit}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onClick(item);
      }}
      onEdit={() => onEdit(item)}
      // @ts-expect-error
      onDuplicate={onDuplicate}
    >
      <LinkWrapper
        url={`${baseUrl}/users/${item.created_by?.id}/about`} className="profile-link"
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
      >
        <div className="EventItem__Creator">
          <ProfileImage enablePopover size={24} user={item.created_by!} />
          <span>
            <Trans
              i18nKey="events:created_by"
              values={{ name: item.created_by?.full_name }}
              components={[<b />]}
            />
          </span>
        </div>
      </LinkWrapper>
    </EventItemComponent>
  );
};
